<meta charset="utf-8">

<div class="modal-header">
 <h4 class="modal-title">{{editMode == 'C' ? 'Crear USUARIO' : 'Editar USUARIO'}}</h4>

 <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
   <span aria-hidden="true">&times;</span>
 </button>
</div>

<div class="modal-body">
 <form [formGroup]="usuarioForm" (ngSubmit)="saveUsuario()">
   <div class="form-group">
     <label for="nombre">Nombre*</label>
     <input type="text" id="nombre" placeholder="Nombre" class="form-control" formControlName="nombre" />
     <span style="color:Red;" *ngIf="usuarioForm.controls['nombre'].touched && usuarioForm.controls['nombre'].errors?.required">Nombre obligatorio.</span>
   </div>
   
   <div class="form-group">
     <label for="fechaAlta">Alta*</label>
        <input type="date" id="fechaAlta" placeholder="dd/mm/yyyy" class="form-control" formControlName="fechaAlta"/>
     <span style="color:Red;" *ngIf="usuarioForm.controls['fechaAlta'].touched && usuarioForm.controls['fechaAlta'].errors?.required">Alta obligatorio.</span>
   </div>
   
   <div class="form-group">
     <label for="rolId">Rol*</label>
    <select id="rolId" class="form-control" formControlName="rolId">
       <option [value]="rol.id" *ngFor="let rol of roles">{{rol.nombre}}</option>
    </select>
     <span style="color:Red;" *ngIf="usuarioForm.controls['rolId'].touched && usuarioForm.controls['rolId'].errors?.required">Rol obligatorio.</span>
   </div>
 </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Cerrar</button>
    <button class="btn btn-primary" (click)="saveUsuario()" [disabled]="usuarioForm.invalid">Guardar</button>
    <button class="btn btn-danger" (click)="handleDeleteClick()" *ngIf="editMode == 'M'">Borrar</button>
</div>
